import { useGet, UseGetOptions } from '../../../hooks/useApi';

interface AttendanceSummaryParams {
  studentId: number;
  startDate?: string;
  endDate?: string;
}

interface AttendanceRecord {
  id: number;
  studentId: number;
  date: string;
  signInTime?: string;
  signOutTime?: string;
  signInSignature?: string;
  signOutSignature?: string;
  parentName: string;
  parentPhone: string;
}

interface AttendanceSummary {
  studentId: number;
  totalDays: number;
  attendedDays: number;
  attendancePercentage: number;
  recentAttendance: AttendanceRecord[];
}

export const useAttendanceSummary = (params: AttendanceSummaryParams) => {
  const queryParams: Record<string, any> = {};

  if (params.startDate) queryParams.startDate = params.startDate;
  if (params.endDate) queryParams.endDate = params.endDate;

  const options: UseGetOptions = {
    queryKey: ['attendanceSummary', params],
    params: queryParams,
    enabled: !!params.studentId,
    staleTime: 5 * 60 * 1000, // 5 minutes
    cacheTime: 10 * 60 * 1000, // 10 minutes
  };

  return useGet<AttendanceSummary>(
    `/v1/auth/attendance/student/${params.studentId}/summary`,
    options
  );
};
